import { Button, List, ListItem, Popover, Typography } from "@material-ui/core";
import { useMemo, useState } from "react";
import ArrowAnimationIcon from "src/components/Icon/ArrowAnimationIcon";
import SearchTextField from "src/components/TextField/SearchTextField";
import { useTokenAnalysisSelector } from "src/context/tokenAnalysisContext";
import useSearchData from "src/hooks/useSearchData";

function searchCategories(element, index, searchText) {
  const temp = searchText
    .toString()
    .toLowerCase()
    .match(/\b(\w+)\b/g);
  var check = true;
  const realSearchText = [].concat(temp);
  if (realSearchText.length === 0) return true;
  for (let i = 0; i < realSearchText.length; i++) {
    if (!element.toString().toLowerCase().includes(realSearchText[i])) check = false;
  }
  return check;
}

export default function CategoryButton({ category, setCategory, ...props }) {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const id = open ? "category-popover" : undefined;

  const [searchText, setSearchText] = useState("");
  const categories = useTokenAnalysisSelector((state) => state.categories);

  const realCategories = useMemo(() => {
    if (categories) {
      const tokenCategories = categories.categories;
      return Object.keys(tokenCategories);
    }
    return [];
  }, [categories]);
  const searchCategory = useSearchData(realCategories, searchText, searchCategories);

  return (
    <>
      <Button color="primary" variant="outlined" onClick={(event) => setAnchorEl(event.currentTarget)} {...props}>
        <Typography>{category ?? "Category"}</Typography>
        <ArrowAnimationIcon isTransform={open} style={{ fontSize: "14px" }} />
      </Button>
      <Popover id={id} open={open} anchorEl={anchorEl} onClose={() => setAnchorEl(null)}>
        <SearchTextField
          fullWidth
          variant="outlined"
          placeholder="Search categories"
          value={searchText}
          event={{ onChange: (value) => setSearchText(value), onClear: () => setSearchText("") }}
        />
        <List>
          {searchCategory.map((element, _) => {
            return (
              <ListItem
                button
                key={element}
                onClick={() => {
                  setCategory(element);
                  setAnchorEl(null);
                }}
              >
                <Typography>{element}</Typography>
              </ListItem>
            );
          })}
        </List>
      </Popover>
    </>
  );
}
